// Angular
import { Injectable } from '@angular/core';
// RxJS
import { Subject } from 'rxjs';
// Object-Path
import objectPath from 'object-path';
// Lodash
import { merge } from 'lodash-es';
// Models
import { LayoutConfigModel } from '../models/layout-config.model';

@Injectable({
	providedIn: 'root',
})
export class LayoutConfigService {
	// Public properties
	onConfigUpdated$: Subject<LayoutConfigModel>;
	layoutConfig!: LayoutConfigModel;
	constructor() {
		// register on config changed event and set default config
		this.onConfigUpdated$ = new Subject();
	}

	saveConfig(layoutConfig: LayoutConfigModel): void {
		if (layoutConfig) {
			localStorage.setItem('layoutConfig', JSON.stringify(layoutConfig));
		}
	}

	getSavedConfig(): LayoutConfigModel | null {
		const config = localStorage.getItem('layoutConfig') || '';
		if (config) return JSON.parse(config);

		return null;
	}

	resetConfig(): void {
		localStorage.removeItem('layoutConfig');
	}

	getConfig(path?: string): LayoutConfigModel | any {
		// merge default layout config with the saved config from layout storage
		// @todo; known issue; viewing 2 or more demos at the time in different browser's tabs, can cause conflict to the layout config
		const c = this.getSavedConfig();
		if (c) this.layoutConfig = c;

		if (path) {
			// if path is specified, get the value within object
			return objectPath.get(this.layoutConfig, path);
		}

		return this.layoutConfig;
	}

	setConfig(value: any, save?: boolean): void {
		this.layoutConfig = merge(this.layoutConfig, value);

		if (save) {
			this.saveConfig(this.layoutConfig);
		}

		// fire off an event that all subscribers will listen
		this.onConfigUpdated$.next(this.layoutConfig);
	}

	getLogo(): string {
		const menuAsideLeftSkin = objectPath.get(this.layoutConfig, 'brand.self.skin');
		// set brand logo
		const logoObject = objectPath.get(this.layoutConfig, 'self.logo');

		let logo;
		if (typeof logoObject === 'string') {
			logo = logoObject;
		}
		if (typeof logoObject === 'object') {
			logo = objectPath.get(logoObject, menuAsideLeftSkin + '');
		}
		if (logo === 'undefined') {
			const logos = objectPath.get(this.layoutConfig, 'self.logo');
			logo = logos[Object.keys(logos)[0]];
		}
		return logo;
	}

	getStickyLogo(): string {
		let logo = objectPath.get(this.layoutConfig, 'self.logo.sticky');
		if (logo === 'undefined') {
			logo = this.getLogo();
		}
		return logo + '';
	}

	loadConfigs(config: LayoutConfigModel) {
		const c = this.getSavedConfig();
		if (c) this.layoutConfig = c;
		// use saved config as priority, or load new config if demo does not matched
		if (!this.layoutConfig || objectPath.get(this.layoutConfig, 'demo') !== config.demo) {
			this.layoutConfig = config;
		}
		this.saveConfig(this.layoutConfig);
	}

	reloadConfigs(): LayoutConfigModel {
		const c = this.getSavedConfig();
		if (c) this.layoutConfig = c;
		this.onConfigUpdated$.next(this.layoutConfig);
		return this.layoutConfig;
	}
}
